module.exports = __webpack_public_path__ + "static/media/lvsShipment.f7ae2288.svg";